<template>
  <div v-if="user && hasReferralCode">
    <PaidContent
      v-if="data?.paidTab"
      v-bind="data.paidTab"
    />
  </div>
  <div v-else-if="user && data?.freeTab?.freeLeftColumnContent?.content">
    <FreeContent
      v-if="data?.freeTab"
      v-bind="data.freeTab"
    />
  </div>
  <div v-else>
    <LoggedOutContent
      v-if="data?.loggedOutTab"
      v-bind="data.loggedOutTab"
    />
  </div>
</template>

<script setup lang="ts">
import PaidContent from './PaidContent.vue';
import FreeContent from './FreeContent.vue';
import LoggedOutContent from './loggedOutContent.vue';
import type { QueryReferAFriendResult } from '~/sanity/types';

const { data } = defineProps<{
  data: QueryReferAFriendResult;
}>();

const { user } = useCrossSession();
const { isPaid } = usePersonalization();
const isPaidUser = computed(() => user.value && isPaid.value);
const hasReferralCode = computed(() => {
  if (!user || !isPaidUser.value) return false;
  if (!user.value?.refCodeData) return false;

  const { refCodeData } = user.value;
  return !refCodeData.isEmpty;
});
</script>
